import React from "react";
import { Link } from "react-router-dom";

interface PendingApprovalModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PendingApprovalModal: React.FC<PendingApprovalModalProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-[#322013] rounded-2xl p-8 max-w-md w-full text-white shadow-lg">
        <h2 className="text-2xl font-bold mb-4 text-[#E8C490]">
          Application Pending
        </h2>
        <p className="mb-6">
          Your application is still under review. Please contact support for
          more information or assistance.
        </p>
        <div className="flex justify-end gap-4">
          <Link
            to="/#"
            className="text-[#E8C490] underline"
          >
            Contact Support
          </Link>
          <button
            onClick={onClose}
            className="bg-[#9A111E] hover:bg-[#7f0f19] text-white font-semibold px-6 py-2 rounded-lg"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PendingApprovalModal;
